
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4.438l.906 2.188 8 19 .906 2.125-2.156-.813L16 24.063l-9.813 3.688.906-2.125 8-19zm0 5.093L9.812 24.25 16 21.937l.344.125 5.844 2.188z"}})])
          )
        }
      }
    